import { VF_MODAL } from 'AppSrc/core/components/forms/form-base-components/v-f-modal';
import {
  INLINE_ERRORS,
  MODAL_ERRORS,
  commonValidation,
  cleanUpFieldErrors,
  getDefaultFieldErrors,
} from 'AppSrc/core/components/forms/form-base-components/utility/common-validation';
import { CHANGE_QUESTIONS } from 'AppSrc/core/components/forms/form-types/create-crq/section-two/section-two';
import { testingStatus } from 'AppSrc/core/components/forms/form-types/create-crq/section-two/testing-status';
import { backoutAndTestCompleted } from 'AppSrc/core/components/forms/form-types/create-crq/section-two/backout-and-test-completed';
// import { customerImpacting } from 'AppSrc/core/components/forms/form-types/create-crq/section-two/customer-impacting';
import { affectsInventoryCmdbOss } from 'AppSrc/core/components/forms/form-types/create-crq/section-two/affects-inventory-cmdb-oss';
import { requiresPreChangeLabTestingResults } from 'AppSrc/core/components/forms/form-types/create-crq/section-two/requires-pre-change-lab-testing-results';
import { requiresNetworkItSecurityApprovalId } from 'AppSrc//core/components/forms/form-types/create-crq/section-two/section-two-constants';
import { fileDb } from 'AppSrc/core/utility-storage/file-db';
import {
  WORK_INFORMATION_ITEM_SUMMARY,
} from 'AppSrc/core/components/forms/form-base-components/summary-components/modal-summary/work-information-item-summary';
import {
  BUSINESS_JUSTIFICATION_FIXED,
  YES_WI_EVIDENCE_ADDED,
  NOT_TESTED_ADD_REASON_WI,
  TEST_RESULTS_DETAILS,
  TEST_PLAN_FIXED,
  TEST_PLAN_MOBILE,
  INSTALL_PLAN_FIXED,
  BOXI_REPORT_FIXED,
  // BACKOUT_PLAN_FIXED,
  OLO_NOTIFICATIONS_FIXED,
  MOBILE,
  FIXED,
  BUSINESS_JUSTIFICATION,
  RISK_STATEMENT,
  CHANGE_JUSTIFICTATION,
  INSTALL_PLAN_MOBILE,
  INVENTORY_FIXED,
  PRE_CHANGE_LAB_TESTING_FIXED,
  NETWORK_IT_SECURIT_ASSESMENT_FIXED,
  IMPACT_LEVEL_1,
  IMPACT_LEVEL_2,
  SERVICE_IMPACT_ASSESSMENT_FIXED,
  SERVICE_IMPACT_ASSESSMENT_MOBILE,
  // TECHNOLOGY_RECOVERY_PLAN,
  // GENERAL_INFORMATION_FIXED,
  AUDIT_FIXED,
  SMIT_REPORT_FIXED,
  preImp1Yes,
  // preImp2Yes,
  preImp3Yes,
  preImp5Yes,
  preImp6Yes,
  CUSTOMER_IMPACT_ASSESMENT,
} from 'AppSrc/core/components/forms/value-dependency-constants';
import { COORDINATOR } from 'AppSrc/core/components/forms/form-base-components/data-structure/constants';
import {
  isCrqExpedited,
  userRoleForSelectedNetwork,
  getIsOlaCrq,
  currentSelectedNetwork,
  getImpactLevel,
  getFieldValueForParameters,
  isCrqEmergency,
} from 'AppSrc/core/components/forms/form-types/create-crq/common-logic';
import { removeDuplications } from 'AppSrc/core/utility-functions/array-fun';
import { WorkInformationItemModal } from './work-information-item-modal';
import { OpenModalButton } from './work-information-open-modal';
import {
  WORK_INFORMATION_ITEMS_FIELD_ID,
  ATTACHED_FILE,
  WORK_INFORMATION_TYPE,
} from './work-information-item-constants';



const fieldId = WORK_INFORMATION_ITEMS_FIELD_ID;




/*
  <🧮>
  Lots of logic to calculate mandatoryWorkInformationItemTypeMessage:
  FN: 22/01/20
  Based on a selection from section 2, we need to make sure the user adds a certain "work information item types". As such
  what all this code does is:
  1. Figure out what if any work information item types are necessary
  2. Goes through all the work information item types that exist (which will have come from server if editing or generated
    in this modal)
  3. Checks if the mandatory work information item type is in the modalSections (which are identical in structure to formSections)
     and if not, returns the correct error message to display requesting the user adds the mandatory work information item
*/


// Some answers in question 2 map onto what fields are mandatory in this section
const testingStatusToWorkInfoTypeMap = {
  [YES_WI_EVIDENCE_ADDED]: TEST_RESULTS_DETAILS,
  [NOT_TESTED_ADD_REASON_WI]: TEST_PLAN_MOBILE,
};

// for more information
const mandatoryWorkInformationItemTypeMessageMap = {
  [TEST_RESULTS_DETAILS]: TEST_RESULTS_DETAILS,
  [TEST_PLAN_FIXED]: 'Test Plan',
  [TEST_PLAN_MOBILE]: 'Test Plan',
  [BUSINESS_JUSTIFICATION]: BUSINESS_JUSTIFICATION,
  [BUSINESS_JUSTIFICATION_FIXED]: 'Business Justification',
  [SERVICE_IMPACT_ASSESSMENT_FIXED]: 'Service Impact Assessment',
  // Since We dont have any work info item for Technology Recovery plan
  // We are utilising Service Impact Assement Mobile (which is not in use) for this functionality.
  [SERVICE_IMPACT_ASSESSMENT_MOBILE]: 'Technology Recovery Plan',
  [AUDIT_FIXED]: 'Technology Recovery Plan',
  [SMIT_REPORT_FIXED]: 'SMIT report',
  [INSTALL_PLAN_FIXED]: 'Install Plan/MOP',
  [BOXI_REPORT_FIXED]: 'BOXI report',
  [OLO_NOTIFICATIONS_FIXED]: 'OLO Notifications',
  // [BACKOUT_PLAN_FIXED]: 'Backout Plan',
  [INVENTORY_FIXED]: 'Inventory',
  [PRE_CHANGE_LAB_TESTING_FIXED]: 'Pre-Change/Lab Testing',
  [NETWORK_IT_SECURIT_ASSESMENT_FIXED]: 'Network/IT Security assessment and approval',
  [RISK_STATEMENT]: RISK_STATEMENT,
  [CHANGE_JUSTIFICTATION]: CHANGE_JUSTIFICTATION,
  [INSTALL_PLAN_MOBILE]: 'Install Plan/MOP',
};
// for more information
// SMIT report and SIA is mandatory WII for circuit check
const mandatoryWorkInformationItemTypeMessageMapCircuitCheck = {
  [SERVICE_IMPACT_ASSESSMENT_FIXED]: 'Service Impact Assessment',
  [SMIT_REPORT_FIXED]: 'SMIT report',
};

const mandatoryWorkInformationItemTypeMessageMapRescheduling = {
  [SERVICE_IMPACT_ASSESSMENT_FIXED]: 'Service Impact Assessment',
  [SMIT_REPORT_FIXED]: 'SMIT report',
  [INSTALL_PLAN_FIXED]: 'Install Plan/MOP',
};

const mandatoryWorkInformationItemTypeMessageMapReschedulingInstallPlan = {
  [INSTALL_PLAN_FIXED]: 'Install Plan/MOP',
};


const mobileCoordinatorMandatoryWITs = [
  TEST_RESULTS_DETAILS,
  RISK_STATEMENT,
  CHANGE_JUSTIFICTATION,
  INSTALL_PLAN_MOBILE,
  CUSTOMER_IMPACT_ASSESMENT,
];










// returns what work information item type is mandatory based on what was selected for testingStatus
const getMandatoryWorkInformationItemTypes = (params) => {
  const {
    formData,
    userRole,
    selectedNetwork,
  } = params;

  const mandatoryWorkInformationItemTypes = [];
  const userIsCoordinator = userRole === COORDINATOR;
  // const isOlaCrq = getIsOlaCrq(formData);
  const changeDetails = 'CHANGE_DETAILS';
  const isOloByService = formData.dataByFormSectionId[changeDetails] ? formData.dataByFormSectionId[changeDetails].dataByFieldId.services.value === 'Network: Other Licensed Operator (OLO)' || formData.dataByFormSectionId[changeDetails].dataByFieldId.services.value === 'Network: International Other Licensed Operator (OLO)' : null;
  const isOlaCrq = getIsOlaCrq(formData) || isOloByService;
  const statusReason = formData.statusReason;


  const changeQuestions = formData.dataByFormSectionId[CHANGE_QUESTIONS];

  /* all network types */
  // mobile only
  const isEmergency = isCrqEmergency(formData);
  if (selectedNetwork === MOBILE && !isEmergency) {

    if (!changeQuestions) {
      console.warn(`UNABLE TO DETERMINE ${testingStatus.id} FROM SECTION TWO, FALLING BACK TO NO WII IS MANDATORY`);
      return null;
    }
    const technologyPlanRequired = 'technology-plan-required';
    const testingStatusValue = changeQuestions.dataByFieldId[testingStatus.id].value;
    const technologyRecoveryPlanResponse = changeQuestions.dataByFieldId[technologyPlanRequired].displayValues[0].value;

    const testingStatusWIT = testingStatusToWorkInfoTypeMap[testingStatusValue];

    if (testingStatusWIT) {
      mandatoryWorkInformationItemTypes.push(testingStatusWIT);
    }
    // Since we dont have any wii for Technology Recovery Plan, we are utilising Service Impact Assessment Mobile For the same
    if (technologyRecoveryPlanResponse === 'Yes') {
      mandatoryWorkInformationItemTypes.push(SERVICE_IMPACT_ASSESSMENT_MOBILE);
    }

    // coordinators should have all the mandatory WIIs from the mobileCoordinatorMandatoryWITs list
    if (userIsCoordinator) {
      mandatoryWorkInformationItemTypes.push(...mobileCoordinatorMandatoryWITs);
    }
  }


  /* fixed only */

  if (selectedNetwork === FIXED && !isOlaCrq && !isEmergency) {

    const impactLevel = getImpactLevel(formData);

    const isExpedite = isCrqExpedited(formData);

    const technologyPlanRequiredFixed = 'technology-plan-required-fixed';

    const technologyRecoveryPlanResponseFixed = changeQuestions.dataByFieldId[technologyPlanRequiredFixed].value[0];

    if (isExpedite) {
      mandatoryWorkInformationItemTypes.push(BUSINESS_JUSTIFICATION_FIXED);
    }
    // Mandatory SMIT & SIA WII removed from fixed CRQ journey and mandatory circuit check stage only
    if (userIsCoordinator && statusReason === '10500' && (impactLevel === IMPACT_LEVEL_1 || impactLevel === IMPACT_LEVEL_2)) {
      mandatoryWorkInformationItemTypes.push(SERVICE_IMPACT_ASSESSMENT_FIXED);
      mandatoryWorkInformationItemTypes.push(SMIT_REPORT_FIXED);
    }

    // if the user is a coordinator, install plan fixed is mandatory
    if (userIsCoordinator) {
      mandatoryWorkInformationItemTypes.push(INSTALL_PLAN_FIXED);
    }

    if (technologyRecoveryPlanResponseFixed === 'Yes') {
      mandatoryWorkInformationItemTypes.push(AUDIT_FIXED);
    }

    const preImp1Value = getFieldValueForParameters({
      formData,
      sectionId: CHANGE_QUESTIONS,
      fieldId: backoutAndTestCompleted.id,
    });
    // Removing mandatory SIA WII from fixed CRQ journey
    // const preImp2Value = getFieldValueForParameters({
    //   formData,
    //   sectionId: CHANGE_QUESTIONS,
    //   fieldId: customerImpacting.id,
    // });

    const preImp3Value = getFieldValueForParameters({
      formData,
      sectionId: CHANGE_QUESTIONS,
      fieldId: affectsInventoryCmdbOss.id,
    });

    const preImp5Value = getFieldValueForParameters({
      formData,
      sectionId: CHANGE_QUESTIONS,
      fieldId: requiresPreChangeLabTestingResults.id,
    });

    const preImp6Value = getFieldValueForParameters({
      formData,
      sectionId: CHANGE_QUESTIONS,
      fieldId: requiresNetworkItSecurityApprovalId,
    });


    if (preImp1Value === preImp1Yes) {
      mandatoryWorkInformationItemTypes.push(INSTALL_PLAN_FIXED);
      // mandatoryWorkInformationItemTypes.push(BACKOUT_PLAN_FIXED);
      mandatoryWorkInformationItemTypes.push(TEST_PLAN_FIXED);
    }

    // if (preImp2Value === preImp2Yes) {
    //   mandatoryWorkInformationItemTypes.push(SERVICE_IMPACT_ASSESSMENT_FIXED);
    // }
    if (preImp3Value === preImp3Yes) {
      mandatoryWorkInformationItemTypes.push(INVENTORY_FIXED);
    }

    if (preImp5Value === preImp5Yes) {
      mandatoryWorkInformationItemTypes.push(PRE_CHANGE_LAB_TESTING_FIXED);
    }

    if (preImp6Value === preImp6Yes) {
      mandatoryWorkInformationItemTypes.push(NETWORK_IT_SECURIT_ASSESMENT_FIXED);
    }
  }

  const isEmergencyCrq = isCrqEmergency(formData);
  // Mandatory WII for OLO CRQ
  if (isOlaCrq && selectedNetwork === FIXED && !isEmergencyCrq) {
    mandatoryWorkInformationItemTypes.push(SERVICE_IMPACT_ASSESSMENT_FIXED);
    mandatoryWorkInformationItemTypes.push(SMIT_REPORT_FIXED);
    mandatoryWorkInformationItemTypes.push(BOXI_REPORT_FIXED);
    mandatoryWorkInformationItemTypes.push(OLO_NOTIFICATIONS_FIXED);
  }

  // Mandatory WII for OLO Emergency CRQ.
  if (isOlaCrq && selectedNetwork === FIXED && isEmergencyCrq) {
    mandatoryWorkInformationItemTypes.push(INSTALL_PLAN_FIXED);
    mandatoryWorkInformationItemTypes.push(SERVICE_IMPACT_ASSESSMENT_FIXED);
  }

  // Mandatory WII for Fixed Emergency CRQ.
  if (selectedNetwork === FIXED && isEmergencyCrq) {
    mandatoryWorkInformationItemTypes.push(INSTALL_PLAN_FIXED);
    mandatoryWorkInformationItemTypes.push(SERVICE_IMPACT_ASSESSMENT_FIXED);
  }

  // Mandatory WII for Mobile Emergency CRQ.
  if (selectedNetwork === MOBILE && isEmergencyCrq) {
    mandatoryWorkInformationItemTypes.push(INSTALL_PLAN_MOBILE);
    mandatoryWorkInformationItemTypes.push(CHANGE_JUSTIFICTATION);
  }

  return mandatoryWorkInformationItemTypes;
};

const getCurrentWorkInformationTypes = (params) => {
  const {
    values,
  } = params;

  const fieldValues = values[fieldId];
  return fieldValues.formSectionsByDisplayOrder.map((formSection) => fieldValues.dataByFormSectionId[formSection].dataByFieldId[WORK_INFORMATION_TYPE].value);
};



const getMandatoryWorkInformationItemTypeMessages = (params) => {
  const {
    formData,
    values,
    userRole,
    selectedNetwork,
  } = params;
  const mandatoryWorkInformationItemTypes = getMandatoryWorkInformationItemTypes({
    formData,
    userRole,
    selectedNetwork,
  });
  // const mandatoryWorkInformationItemTypess=['9000','9250'];
  const mandatoryWorkInformationItemTypeMessages = [];
  const statusReason = formData.statusReason;
  const currentWorkInformationTypes = getCurrentWorkInformationTypes({
    values,
  });
  const impactLevelwii = getImpactLevel(formData);


  if (statusReason === '10500') {
    const dataMap = window.localStorage.getItem('dataMap');
    const isSIA = currentWorkInformationTypes.includes('9000', dataMap);
    const isSMIT = currentWorkInformationTypes.includes('9250', dataMap);
    let currentWorkInformationTypes1 = [];
    if (isSIA === true) {
      currentWorkInformationTypes1 = currentWorkInformationTypes.slice(dataMap);
    }
    if (isSMIT === true) {
      currentWorkInformationTypes1 = currentWorkInformationTypes.slice(dataMap);
    }

    mandatoryWorkInformationItemTypes.forEach((mandatoryWIT) => {
      const hasMadatoryWit = currentWorkInformationTypes1.includes(mandatoryWIT);


      if (hasMadatoryWit) {
        return null;
      }


      const mandatoryWitMessage = mandatoryWorkInformationItemTypeMessageMapCircuitCheck[mandatoryWIT];
      // console.log('Mandatory WIT', mandatoryWIT);
      // if (!mandatoryWitMessage) {
      //   console.error(`Unable provide proper message for mandatoryWIT: ${mandatoryWIT}, falling back to using
      //   ${mandatoryWIT}`);
      //   mandatoryWorkInformationItemTypeMessages.push(mandatoryWIT);
      //   return null;
      // }


      mandatoryWorkInformationItemTypeMessages.push(mandatoryWitMessage);
      return null;
    });
  }
  else if (statusReason === 'PostponedCRQ' && formData.status === '3' && selectedNetwork === 'fixed' && (impactLevelwii === '1000' || impactLevelwii === '2000')) {
    const dataMap1 = window.localStorage.getItem('dataMap1');
    const isSIA = currentWorkInformationTypes.includes('9000', dataMap1);
    const isInstall = currentWorkInformationTypes.includes('14000', dataMap1);
    const isSMIT = currentWorkInformationTypes.includes('9250', dataMap1);
    let currentWorkInformationTypes2 = [];
    if (isSIA === true) {
      currentWorkInformationTypes2 = currentWorkInformationTypes.slice(dataMap1);
    }
    if (isSMIT === true) {
      currentWorkInformationTypes2 = currentWorkInformationTypes.slice(dataMap1);
    }
    if (isInstall === true) {
      currentWorkInformationTypes2 = currentWorkInformationTypes.slice(dataMap1);
    }

    mandatoryWorkInformationItemTypes.forEach((mandatoryWIT) => {
      const hasMadatoryWit = currentWorkInformationTypes2.includes(mandatoryWIT);


      if (hasMadatoryWit) {
        return null;
      }
      // let messagesToShow = [];
      // if (selectedNetwork === 'fixed') {
      //   if (impactLevelwii === '1000' || impactLevelwii === '2000') {
      //     messagesToShow = mandatoryWorkInformationItemTypeMessageMapRescheduling;
      //   }
      //   else {
      //     messagesToShow = mandatoryWorkInformationItemTypeMessageMapReschedulingInstallPlan;
      //   }
      // }
      // if (selectedNetwork === 'mobile') {
      //   messagesToShow = mandatoryWorkInformationItemTypeMessageMapReschedulingInstallPlan;
      // }

      const mandatoryWitMessage = mandatoryWorkInformationItemTypeMessageMapRescheduling[mandatoryWIT];
      // console.log('Mandatory WIT', mandatoryWIT);
      // if (!mandatoryWitMessage) {
      //   console.error(`Unable provide proper message for mandatoryWIT: ${mandatoryWIT}, falling back to using
      //   ${mandatoryWIT}`);
      //   mandatoryWorkInformationItemTypeMessages.push(mandatoryWIT);
      //   return null;
      // }


      mandatoryWorkInformationItemTypeMessages.push(mandatoryWitMessage);
      return null;
    });
  }
  else if (statusReason === 'PostponedCRQ' && formData.status === '3' && selectedNetwork === 'mobile') {
    const dataMap2 = window.localStorage.getItem('dataMap2');
    // const isSIA = currentWorkInformationTypes.includes('14000', dataMap);
    const isInstall = currentWorkInformationTypes.includes('14000', dataMap2);
    // const isSMIT = currentWorkInformationTypes.includes('9250', dataMap);
    let currentWorkInformationTypes3 = [];
    // if (isSIA === true) {
    //   currentWorkInformationTypes1 = currentWorkInformationTypes.slice(dataMap);
    // }
    // if (isSMIT === true) {
    //   currentWorkInformationTypes1 = currentWorkInformationTypes.slice(dataMap);
    // }
    if (isInstall === true) {
      currentWorkInformationTypes3 = currentWorkInformationTypes.slice(dataMap2);
    }

    mandatoryWorkInformationItemTypes.forEach((mandatoryWIT) => {
      const hasMadatoryWit = currentWorkInformationTypes3.includes(mandatoryWIT);


      if (hasMadatoryWit) {
        return null;
      }
      // let messagesToShow = [];
      // if (selectedNetwork === 'fixed') {
      //   if (impactLevelwii === '1000' || impactLevelwii === '2000') {
      //     messagesToShow = mandatoryWorkInformationItemTypeMessageMapRescheduling;
      //   }
      //   else {
      //     messagesToShow = mandatoryWorkInformationItemTypeMessageMapReschedulingInstallPlan;
      //   }
      // }
      // if (selectedNetwork === 'mobile') {
      //   messagesToShow = mandatoryWorkInformationItemTypeMessageMapReschedulingInstallPlan;
      // }

      const mandatoryWitMessage = mandatoryWorkInformationItemTypeMessageMapReschedulingInstallPlan[mandatoryWIT];
      // console.log('Mandatory WIT', mandatoryWIT);
      // if (!mandatoryWitMessage) {
      //   console.error(`Unable provide proper message for mandatoryWIT: ${mandatoryWIT}, falling back to using
      //   ${mandatoryWIT}`);
      //   mandatoryWorkInformationItemTypeMessages.push(mandatoryWIT);
      //   return null;
      // }


      mandatoryWorkInformationItemTypeMessages.push(mandatoryWitMessage);
      return null;
    });
  }
  else {
    mandatoryWorkInformationItemTypes.forEach((mandatoryWIT) => {
      const hasMadatoryWit = currentWorkInformationTypes.includes(mandatoryWIT);

      if (hasMadatoryWit) {
        return null;
      }


      const mandatoryWitMessage = mandatoryWorkInformationItemTypeMessageMap[mandatoryWIT];
      if (!mandatoryWitMessage) {
        console.error(`Unable provide proper message for mandatoryWIT: ${mandatoryWIT}, falling back to using
        ${mandatoryWIT}`);
        mandatoryWorkInformationItemTypeMessages.push(mandatoryWIT);
        return null;
      }


      mandatoryWorkInformationItemTypeMessages.push(mandatoryWitMessage);
      return null;
    });
  }


  // we want to clean up duplicated messages. This should also prevent the need to upload mutlitple WIIs of the same type
  const messages = removeDuplications(mandatoryWorkInformationItemTypeMessages);

  return messages;
};

/*
  End of complicated logic
  </🧮>
*/


const validator = (params) => {
  const {
    values,
    field,
    formData,
    userRoles,
  } = params;
  const {
    optional,
  } = field;
  const userRole = userRoleForSelectedNetwork(formData, userRoles);
  const selectedNetwork = currentSelectedNetwork(formData);

  /* MAKE A DEFAULT ERRORS OBJECT */
  const errors = getDefaultFieldErrors();


  /* ERROR CHECKERS */
  const noValue = commonValidation.noValue(values[fieldId], VF_MODAL);
  const mandatoryWorkInformationItemTypeMessages = getMandatoryWorkInformationItemTypeMessages({
    formData,
    values,
    userRole,
    selectedNetwork,
  });

  /* ADD ERRORS TO ERROR OBJECT */
  errors[INLINE_ERRORS].push((noValue && !optional) ? 'Please add Work Info Item' : null);
  errors[MODAL_ERRORS] = [
    ...errors[MODAL_ERRORS],
    ...mandatoryWorkInformationItemTypeMessages,
  ];

  /* REMOVE BLANK ERRORS (because Formik gets confused) */
  return cleanUpFieldErrors(errors);
};




const initialValues = {
  formSectionsByDisplayOrder: [],
  dataByFormSectionId: {},
};

const onRowDeletion = (params) => {
  const {
    value,
    sectionIdToDelete,
  } = params;
  // this gives you a row of data to be deleted. Amoungst this is the fileId
  const rowToBeDelete = value.dataByFormSectionId[sectionIdToDelete];
  const fileId = rowToBeDelete.dataByFieldId[ATTACHED_FILE].value;

  if (fileId) {
    fileDb.markForDeletion(fileId);
  }
};


const vFParams = {
  // Component that fires a callback to open the modal
  OpenModalComponent: OpenModalButton,
  // The modal to open
  ModalSection: WorkInformationItemModal,
  // A summary section for the data entered in the modal
  /* NOTE: This may end up having to change to a key, ie, how we do fieldType so we can put it on the summary page */
  modalSummaryType: WORK_INFORMATION_ITEM_SUMMARY,
  // SummarySection: WorkInformationItemSummary,
  onRowDeletion,
  onRowDeletionAlert: {
    alertTitle: 'Are you sure you want to delete this work information item?',
    alertText: 'Please note this will permanently delete this work information item and cannot be recovered.',
  },
  onCancelAlert: {
    alertTitle: 'Are you sure you want to exit without saving this Work Info Item?',
    falseText: 'No',
    trueText: 'Yes, exit without saving',
    trueButtonCols: 4,
  },
  modalErrorsTitle: 'Based on your selections the following work information items are mandatory:',
};

const workInformationItems = {
  id: fieldId,
  validator,
  initialValues,
  vFParams,
  fieldType: VF_MODAL,
};

export { workInformationItems };
